import SupDeliveryModule from './supDelivery/SupDeliveryModule';
import SupProductModule from './supProduct/SupProductModule';
import SupCostModule from './supCost/SupCostModule';
import SupLicenseModule from './supLicense/SupLicenseModule';
import OffCostModule from './offCost/OffCostModule';

import SupOperationModule from './supOperation/SupOperationModule';
import OffDeliveryModule from './offDelivery/OffDeliveryModule';
import OffProductModule from './offProduct/OffProductModule';

// 懒加载组件
const SupDeliveryModuleSubRouter = SupDeliveryModule.map(router => (
  {
    path: '/SupDelivery' + router.path,
    component: router.component
  }
));
const SupProductModuleSubRouter = SupProductModule.map(router => (
  {
    path: '/SupProduct' + router.path,
    component: router.component
  }
));
const SupCostModuleSubRouter = SupCostModule.map(router => (
  {
    path: '/supCost' + router.path,
    component: router.component
  }
));
const SupLicenseModuleSubRouter = SupLicenseModule.map(router => (
  {
    path: '/SupLicense' + router.path,
    component: router.component
  }
));
const SupOperationModuleSubRouter = SupOperationModule.map(router => (
  {
    path: '/SupOperation' + router.path,
    component: router.component
  }
));
const OffDeliveryModuleSubRouter = OffDeliveryModule.map(router => (
  {
    path: '/OffDelivery' + router.path,
    component: router.component
  }
));

const OffCostModuleSubRouter = OffCostModule.map(router => (
  {
    path: '/offCost' + router.path,
    component: router.component
  }
));

const OffProductModuleSubRouter = OffProductModule.map(router => (
  {
    path: '/offProduct' + router.path,
    component: router.component
  }
));

export const subRoutes = [
  ...SupDeliveryModuleSubRouter,
  ...SupProductModuleSubRouter,
  ...SupCostModuleSubRouter,
  ...SupLicenseModuleSubRouter,
  ...OffCostModuleSubRouter,
  ...SupOperationModuleSubRouter,
  ...OffDeliveryModuleSubRouter,
  ...OffProductModuleSubRouter
];
